<h2 mat-dialog-title>Ajouter une entrée</h2>
<mat-dialog-content>
    <form [formGroup]="usageRateAreaForm">
        <mat-form-field class="w-full">
            <mat-label>Area</mat-label>
            <input type="text" placeholder="FRA-Mobile" matInput formControlName="area" [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete">
            @for (area of filteredAreas | async; track area.name) {
                <mat-option [value]="area.name">{{ area.country.flag }} {{ area.country.name_fr }} - {{ area.is_landline ? 'Fixe' : 'Mobile' }}</mat-option>
            }
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="w-full">
            <mat-label>Tarif</mat-label>
            <input matInput type="number" placeholder="0,6372" formControlName="price" step="0.0001">
            <span matTextSuffix> €</span>
        </mat-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button matButton [mat-dialog-close]>Annuler</button>
    <button matButton (click)="submit()">Valider</button>
</mat-dialog-actions>